export const getProductMaterials = (product = {}) => {
  const source = Array.isArray(product.materials) && product.materials.length
    ? product.materials
    : [product.material];
  const seen = new Set();

  return source
    .map((value) => String(value || '').trim())
    .filter((value) => {
      const key = value.toLowerCase();

      if (!key || seen.has(key)) {
        return false;
      }

      seen.add(key);
      return true;
    });
};

export const productMatchesMaterials = (product, selectedMaterials = []) => {
  if (!selectedMaterials.length) {
    return true;
  }

  const available = new Set(getProductMaterials(product).map((value) => value.toLowerCase()));
  return selectedMaterials.some((value) => available.has(String(value || '').trim().toLowerCase()));
};

const normalizeGenderValue = (value) => {
  const normalized = String(value || '').trim().toLowerCase();

  if (['male', 'man', 'men'].includes(normalized)) {
    return 'man';
  }

  if (['female', 'woman', 'women'].includes(normalized)) {
    return 'woman';
  }

  return normalized;
};

export const productMatchesSelectedGenders = (product = {}, selectedGenders = []) => {
  if (!selectedGenders.length) {
    return true;
  }

  const productGender = normalizeGenderValue(product.gender || product.sex);

  if (!productGender) {
    return false;
  }

  return selectedGenders.some((gender) => {
    const selectedGender = normalizeGenderValue(gender);

    return productGender === selectedGender || (selectedGender !== 'unisex' && productGender === 'unisex');
  });
};
